import { createContext, useContext } from "react";

interface ISessionContext {
  name: string | undefined;
  role: string | undefined;
  updateSession: () => void;
}

const defaultState: ISessionContext = {
  name: "",
  role: "",
  updateSession: () => {
    console.warn("SessionContext: not in scope.");
  },
};

export const SessionContext = createContext<ISessionContext>(defaultState);
export const useSessionContext = () => useContext(SessionContext);
